<template>

  <div class="">
    <p>{{ $t('views.shortener') }}</p>
  </div>
  
</template>

<script>

export default {
  name: 'Shortener',
  created() {
    var self = this;
    var user = (this.$route.params.user_id) ? this.$route.params.user_id : null;
    this.$store.dispatch( 'files/loadShortener', {resource_id: this.$route.params.id, user_id: user} ).then(function(){
      location.replace(self.$store.getters['files/getInform']);
    });
  },
}

</script>
